<template lang="pug">
v-card
      v-app-bar(
        :color='colorTheme'
        class="navFixed"
      )
        img(
            class="mr-2" 
            :src="require('../assets/Logo-iMemo.png')" 
            height="40"
            @click="$router.push('/')" 
            style="cursor: pointer;"
          )
        v-toolbar-title(
          @click="$router.push('/')" 
          class="align-self-center"
          style="cursor: pointer; font-size: 24px; font-weight: 600; color: white"
        ) IM Preview
        v-spacer
        v-toolbar-items
  
          v-btn(v-if="imItems.imFileLampiran" flat @click="download(imItems.imFileLampiran)" title="Download Lampiran")
            v-icon cloud_download
            | &nbsp; Lampiran v-if="imItems.already_submit!=true"
          v-btn(v-if="imItems.already_submit!=true" dark text title='Approval' @click="approvalDialog = true;genImCode()") 
            v-icon(title="Approval") assignment_turned_in
            | &nbsp;Approval
          v-dialog(v-model="approvalDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2") Approval Form
              v-card-text
                v-layout(wrap)
                  v-flex(xs12)
                      v-alert(v-if="otp_success==true" color="green" outlined style="font-size:12px;").mt-1 Kode OTP berhasil dikirimkan ke eMail dan Whatsapp Anda.
                  v-flex(xs12)
                    v-radio-group(v-model="approval" row)
                      v-radio(v-if="dialogType === 'ho' && imItems.imStatus != 3" label="Approve" color="success" value="approved")
                      v-radio(v-if="dialogType != 'ho' && imItems.imStatus != 3" label="Approve" color="success" value="approved")
                      v-radio(v-if="imItems.imStatus != 3" label=`Reject` color="red" value="rejected")
                      v-radio(label="Need Review" color="yellow darken-4" value="need-review")
                    span(v-if="approval == 'need-review'" style="color:#ff2c03;") Approval akan dimulai lagi dari approver yang dipilih!
                  v-flex(v-if="approval == 'need-review'" xs12)
                    v-select(
                      v-model="select"
                      :hint="jabatan"
                      :items="reviewer"
                      item-text="name"
                      item-value="id"
                      label="Select"
                      persistent-hint
                      return-object
                      single-line
                      dense)
                  v-flex(xs12)
                    v-textarea(
                      v-model="comment"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )
                    b Masukan kode OTP untuk dokumen 
                  div(class="d-flex flex-row align-center"  style="max-width: 380px;")
                    v-otp-input(v-model="otp" length='4' type='string' style="height:40px").mr-2
                    v-btn(small flat style="font-size:11px;margin-left:0px;" @click.native="otp=null") Clear Input
                  v-flex(v-if="dialogType === 'site'" xs12)
                    v-subheader(class="pa-0") File Uji Teknis
                    input(type="file" id="file" ref="file" v-on:change="handleFileUpload()" accept=".pdf, .doc, .docx")
              v-card-actions.mt-8
                v-spacer
                v-btn.mr-2( color="green" elevation="2" outlined @click.native="reSendOtp()") Resend OTP
                v-btn.mr-2(color="red darken-1" flat outlined @click.native="approvalDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="!select.hasOwnProperty('id') && approval == 'need-review'"  outlined :loading="approvalDialog2" color="blue darken-1" flat @click="approvalDialog2 = true;submitApproval()") Submit
                  v-dialog(
                    v-model="approvalDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")
                  v-dialog(
                    v-model="dialogTg"
                    persistent
                    max-width="320px")
                    v-card(class="dialog-card")
                        v-card-actions(class="headline grey lighten-2"
                        primary-title)
                          v-list-tile
                            img(src="../assets/telegram_icon.png" style="margin:-10px" width="35px")
                          span(style="margin: 5px 0 0 10px") Information
                          v-spacer
                          v-list-tile
                            img(src="../assets/imemo_icon.png" width="80px")
                        v-card-text
                          h3(style="text-align: center; font-weight:normal;") IMemo saat ini sudah terintegrasi dengan Telegram, apakah anda ingin mendapatkan notif dari Telegram juga?
                          <br/>
                          input(style="margin-left: 5%" type="checkbox" id="tgCheckbox" v-model="tgDontRemind")
                          label(for="tgCheckbox" class="tgLbl") Don't Remind Me
                          v-card-actions
                            v-spacer
                            v-btn(color="blue darken-1" flat="flat" @click="tgRegister") Iya
                            v-btn(color="green darken-1" flat="flat" @click="tgDialogClose") Tidak
          v-btn(dark text @click="imItems.imStatus==4||imItems.imStatus==8 ? print=true : printIM(imItems.im_number)")
            v-icon print
            | &nbsp; Print 
          v-dialog(v-model="print" persistent max-width="450px")
                v-card
                  v-card-title(class="headline grey lighten-2") Print Document
                  v-alert(:value='true' color="success")
                    h3(style="text-align: center; font-weight:normal") To save the trees, please think to share it rather than print.
                  v-flex(class="text-xs-center")
                    v-btn(text @click="printIM(imItems._id); print = false;")
                      v-icon print
                      | &nbsp; Print
                    v-btn(text @click="print = false; shareIM();")
                      v-icon share
                      | &nbsp; Share
                  v-spacer
                  v-flex(class="text-xs-right")
                    v-btn(color="blue darken-1" flat @click.native="print = false") Close
          v-btn(v-if="imItems.imStatus==4||imItems.imStatus==8" flat @click="shareIM()")
            v-icon share
            | &nbsp; Share 
          v-dialog(v-model="share" persistent max-width="350px")
            v-card
                v-card-title(class="headline grey lighten-2") Share
                v-flex(class="text-xs-center")
                  ShareNetwork(v-for="network in networks" :key="network.key" :network="network.network" :title="network.network=='whatsapp' ? 'Subject: '+ sharing.title+' \\nBody: \\n' : sharing.title " :url="shortenUrl" :description="sharing.description")
                    img(:src="network.img" width="80px" style="margin:20px 15px;")
                v-spacer
                v-flex(class="text-xs-right")
                  v-btn(color="blue darken-1" flat @click.native="share=false") Close
          v-btn(dark text @click="$router.go(-1)")
            v-icon(title="Close") cancel
            | &nbsp;Close
      v-list(three-line subheader class="print-bg padTop60")
        div(:id="imItems.im_number")
          .page(size="Auto")
            //- table(id="header-view" class="view-width print-header")
            //-   tbody
                //- tr
                //-   td(v-if="imItems.imType != 9 && imItems.imType != 10" class="logo-cell") 
                //-     //- img(v-if="imItems.imGroup === 'gems'" src="../assets/smm-logo.png" class="width-300px")
                //-     //- img(v-if="imItems.imGroup === 'bcg'" :src="../assets/bc-logo-188.png" class="width-300px")
                //-     //- img(v-if="imItems.imGroup == 'nongroup' && imItems.imCompany != 'Others' " :src="ngCompany" class="width-300px")
                //-     img(v-if="(imItems.imCompany != 'Others' && imItems.imCompany == 'Sun Energy Group') && showImg==true " :src="imgSrc" class="width-150px")
                //-     img(v-else-if="(imItems.imCompany != 'Others') && showImg==true " :src="imgSrc" class="width-300px")
                //-   td(v-else class="logo-cell") 
                //-     img(v-if="imItems.imGroup === 'bc'" src="../assets/bc-logo-188.png" class="width-300px")
                //-     img(v-if="imItems.imGroup === 'bce'" src="../assets/bce-logo-188.png" class="width-300px")
                //-     img(v-if="imItems.imGroup === 'mtl'" src="../assets/mtl-logo-188.jpg" class="width-300px")
            div(class="view-width" style="font-size:14px;")
              h2(style="text-align:center;padding:5px;") INTERNAL MEMO
              
              hr(style="border-style: inset;border-width: 2px;")
            
              table(class="view-width" style="margin-top:10px;")
                tbody
                  tr
                    td(style="font-size:15px;width:40%;") 
                      strong KEPADA / TO : BAPAK/IBU
                    td(style="font-size:15px;")
                      strong DARI / FROM :
                  tr
                    td(valign="top")
                      ul
                        li(v-for="(requestor, i) in imItems.workflow.slice().reverse()" :key="i" style="font-size:15px;" v-if="requestor.status != 5")
                          span(v-if="requestor.fullname") {{ requestor.fullname }}
                          span(v-else) {{ requestor.name }}
                    td(valign="top")
                      ul(style="list-style-type: none; padding:0;")
                        
                        li(style="font-size:15px;border-bottom:1px solid grey;") {{ imItems.creator.name }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong NOMOR / NUMBER
                          br
                          | {{ imItems.im_number }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong TANGGAL / DATE
                          br
                          | {{ getTanggal(imItems.date_submit)  }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong PERIHAL / ISSUE
                          br
                          | {{ imItems.events }}
              
          
              hr(style="border-style: inset;border-width: 2px; paddid-top:2px;")
              
              div(style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") TUJUAN 
                div(v-html="imItems.goals" class="ck-content")
              div(style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") LATAR BELAKANG
                div(v-html="imItems.background_creation" class="ck-content")
              div(style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") MENGUSULKAN
                div(v-html="imItems.purpose" class="ck-content")
             
              div(style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") TARGET DELIVERY DATE
                div(v-html="getTanggal(imItems.target_live)")
              
                span(v-if="i !== imItems.imLiv.length-1" v-for="(item, i) in imItems.imLiv" :key="i") {{item}}, 
                span(v-else) {{item}}
              div(v-if="imItems.imType == 1 || imItems.imType == 2" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") Nomor Dokumen SAP
                div(v-html="imItems.imNoDocument")
              div
                h4(style="font-size:15px;")
                p Demikian permohonan ini kami buat, atas persetujuan Bapak/Ibu, kami ucapkan terima kasih.
              div(v-if="imItems.imType == 6" style="text-align:justify;margin-top:15px;")
                div(v-html="imItems.purpose" class="ck-content")
            //div(style="position:absolute;bottom:20px;right:35px;font-size:12px") {{ imItems.imNo }}
          .page(size="Auto" style="height:auto;" class="pagebreak")
            table(id="header-view" class="view-width print-header")
              tbody
                tr
                  td(v-if="imItems.imType != 9 && imItems.imType != 10" class="logo-cell" ) 
                    //- img(v-if="imItems.imGroup === 'gems'" src="../assets/smm-logo.png" class="width-300px")
                    //- img(v-if="imItems.imGroup === 'bcg'" src="../assets/bc-logo-188.png" class="width-300px")
                    //- img(v-if="imItems.imGroup == 'nongroup' && imItems.imCompany != 'Others' " :src="ngCompany" class="width-300px")
                    img(v-if="(imItems.imCompany != 'Others' && imItems.imCompany == 'Sun Energy Group') && showImg==true " :src="imgSrc" class="width-150px")
                    img(v-else-if="(imItems.imCompany != 'Others') && showImg==true" :src="imgSrc" class="width-300px")
                  td(v-else class="logo-cell") 
                    img(v-if="imItems.imGroup === 'bc'" src="../assets/bc-logo-188.png" class="width-300px")
                    img(v-if="imItems.imGroup === 'bce'" src="../assets/bce-logo-188.png" class="width-300px")
                    img(v-if="imItems.imGroup === 'mtl'" src="../assets/mtl-logo-188.jpg" class="width-300px")
            p(style="font-size:14px;font-weight:bold;margin-bottom:-10px;") Approval list for IM No : {{imItems.im_number}}
            div(class="view-width detail-wrap" style="position:relative;font-size:14px;height:auto;")
              div(id="background")
                img(v-if="imItems.status.name == 'draft'" src="img/draft.png" class="imgWaterMark")
                img(v-if="imItems.status.name == 'on_approval'" src="img/on-approval.png" class="imgWaterMark")
                img(v-if="imItems.status.name == 'full_approval'" src="img/fully-approved.png" class="imgWaterMark")
                img(v-if="imItems.status.name == 'withdraw'" src="img/withdraw.png" class="imgWaterMark")
                img(v-if="imItems.status.name == 'rejected'" src="img/rejected.png" class="imgWaterMark")
              table(class="view-width" border="1" style="margin:10px 0;border:1px solid black;border-collapse: collapse;text-align:center;z-index:100;")
                tbody
                  tr
                    td(colspan="3" style="") 
                      b Diajukan oleh,
                  tr
                    td(width="36%") 
                      b Nama/Jabatan
                    td(width="32%") 
                      b Komentar
                    td(width="32%")
                      b Tanda Tangan Digital
                  tr(height="80px")
                    td(width="40%" class="px-3")
                      b {{ imItems.creator.name }} / {{ imItems.creator.position }} 
                    td 
                      div 
                    td 
                     
                      div(class="approved")
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(imItems.date_submit) }}

                  tr
                    td(colspan="3" align="center" style="") 
                      b Disetujui oleh, 
                  tr
                    td(width="36%") 
                      b Nama/Jabatan
                    td(width="32%") 
                      b Komentar
                    td(width="32%")
                      b Tanda Tangan Digital
                  tr(v-for="(item, index) in imItems.workflow"  :key="index" v-if="item.postAs !== 'requestor' && imItems.imType != 9 && item.status != 5" height="80px")
                    
                    td(width="40%" class="px-3")
                      b {{   item.fullname ? item.fullname : item.name }} / {{ item.position }}
                    td
                      div {{item.comment}}

                    td
                      div(v-if="item.status.name == 'approved'" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.updated_at) }}<br />
                      div(v-else-if="imItems.imStatus == 3 && item.date" class="approved") 
                        | {{ getTanggal(item.updated_at) }}
                        br
                        | (Need Reapproval) 
                      div(v-else-if="item.status.name == 'rejected'" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.updated_at) }}<br />
                      div(v-else-if="imItems.imStatus == 2 && imItems.hasOwnProperty('imReturn') && item.date" class="approved")
                        | {{ getTanggal(item.updated_at) }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 8 && imItems.hasOwnProperty('imReturn') && item.date" class="approved")
                        | {{ getTanggal(item.updated_at) }}
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />

              span(style="font-size:14px;color:black;margin-left:10%") Scan QR code untuk memvalidasi kebenaran informasi atas tanda tangan digital di dokumen ini.
              p
                img(:src="imItems.qr" style="vertical-align:middle;width:120px;margin-left:40%")
</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
import * as i18n from ".././data/i18n.json";
import printJS from 'print-js';
export default {
  name: "imApprove",
  data: () => ({
    imItems:null,
    i18n: i18n.default,
    dialog: false,
    approvalBtn: false,
    approvalDialog: false,
    approvalDialog2: false,
    dialogTg: false,
    tgDontRemind: false,
    comment: null,
    approvalflag: false,
    approval: null,
    kepadas: [],
    select: {},
    print:false,
    share:false,
    forwardNote: null,
    userForward: {},
    forwardDialog: false,
    forwardDialog2: false,
    reviewer: [],
    qrImage: `/img/icons/loading.gif`,
    imgSrc:'',
    showImg:false,
    otp_success:false,
    otp:null,
    need_creator:false
  }),
  computed: {
    ...mapState(["API_URL", "WE_URL", "sharing", "networks","shortenUrl","dataUsers"]),
   
       
    colorTheme: function() {
      
      //- const isBerau = this.$store.state.dataUsers.username.match(/berau/g);
      //- return isBerau ? "#4bb034" : "#ED1B24";
      return  "#D42A2A";
    },
  },
  mounted() {
     this.getData()
     
  },
  methods: {

    reSendOtp: function() {
            const config = {
              method:"post",
              url:process.env.VUE_APP_API+`/approval/request/otp`,
               data:{code:this.$route.params.id}
            };
            let otp = axios(config).then(res => {
                this.otp_success = true
                this.$toasted.success(res.data.message)
              }).catch(err => {
            this.$toasted.error(err)
          });
          },
          
    genImCode: async function() {
              const config = {
                method: "post",
                url: process.env.VUE_APP_API+`/approval/request/otp`,
                data:{code:this.$route.params.id}
              };
              let otp = await axios(config);
              if (otp.status == 200) {
                this.otp_success = true
                this.genAlertShow = 'display:;';
              }
      },

    getData(){
      axios.get(process.env.VUE_APP_API+`/approval/verified/${this.$route.params.id}`)
              .then(res => {
                let data  = res.data.workflow.forEach((item) =>{
                    if(item.id!=res.data.current_approval.id && item.status.name != 'idle'){
                        this.reviewer.push(item)
                    }
                })
                
                this.reviewer.push(res.data.creator)

                
                res.data.comments.forEach((item, index) => {

                   let data = res.data.comments.filter(function (el)
                          {
                               if(el.id == res.data.workflow[index].id){
                                return el
                               }
                          })
                    res.data.workflow[index].comment = data[0].comment
                })

                this.imItems = res.data
                
              }).catch(err => {
                
              this.$toasted.error(err)
             return this.$router.push('/')
        });
    },
    submitApproval: async function(){
       const config = {
              method:"post",
              url:process.env.VUE_APP_API+`/approval/submit/${this.$route.params.id}`,
               data:{
                  otp:this.otp,
                  approve_type: this.approval,
                  reason: this.comment,
                  user_bu: this.imItems.current_approval.id,
                  email: this.imItems.current_approval.email,
                  need_creator: this.select.id == this.imItems.creator.id ? true :  false
                }
            };

             axios(config).then(res => {
                this.approvalDialog2 = false
                this.approvalDialog = false
                this.$toasted.success(res.data.data.message)
                window.location.reload()
              }).catch(err => {
            this.$toasted.error(err)
          });
    },
    getTanggal: function(tgl) {
      let monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
      let tanggal = new Date(tgl);
      let month = tanggal.getMonth();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      return date+' '+monthNames[month]+' '+tanggal.getFullYear();
    },
    printIM: function(id) {
      printJS({
        printable: id, 
        type: 'html',
        scanStyles: false,
        css: ["/stylesheets/approval.css", "/stylesheets/vuetify.min.css", "/stylesheets/ck-content.css"]
      });
    },

  },


  watch: {

  }
};
</script>

<style scoped>
.print-bg {
  background: rgb(204,204,204) !important;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 13px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.width-150px {
  width: 150px;
}
.top-align {
  vertical-align:top;
}

.tgLbl {
  position: relative;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
  .page[size="Auto"] {
    width: auto;
    margin:0 auto;
    display:block;
    text-align:initial;
  }
  table { page-break-inside:auto; }
  tr    { page-break-inside:avoid; page-break-after:auto; }
  .pagebreak { page-break-before: always; } /* page-break-after works, as well */
  p { page-break-after: auto; page-break-before: auto; page-break-inside: avoid; }
  .image {padding: 5%; page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
  .table {page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:0px;
  left:0px;
  text-align: right;
  width: 100%;
}
.imgWaterMark {
  width: 201px;
  position:absolute;
  top:0px;
  right:35px;
}
</style>